import { AccountFactory } from '@/Domain/Account/AccountFactory'
import { AxiosAccountData } from './AxiosAccountData'
import { AccountFactoryError, Account, AccountName, AccountId, Token } from '@/Domain/Account'

export class AxiosAccountFactory implements AccountFactory<AxiosAccountData> {
  makeAccount (data: AxiosAccountData): Account {
    try {
      return new Account(
        new AccountName(data.userName),
        new AccountId(data.userNif),
        new Token(data.token)
      )
    } catch (error) {
      throw new AccountFactoryError(error.message)
    }
  }
}
